import { cn } from "@/lib/utils";

export default function BlueLight({ className }: { className?: string   }) {
    return (
        <div className={cn("absolute bg-blue-light blur-[75px]", className)} />
    )
}